'use strict';

var triggerCustomEvent = require('trigger-custom-event');

const appDom = require('./app-dom');

// var appDom = require('./app-dom');
// var dataMgr = require('./data-mgr');

// var setCrumb = function() {

// 	appDom.galleryCrumb.html(dataMgr.getGalleryMeta().name);

// };

var addEventHandlers = function() {

	// appDom.document.on('gallery_data_ready', setCrumb);

	appDom.eventCrumb.on('click', function() {

		triggerCustomEvent('breadcrumb_event_name_clicked', {
			data: {
				galleryIndex: 0					
			}
		});

	});

};

var init = function() {

	addEventHandlers();

};

module.exports = {

	init: init

};
